const KEY = "iam_ref";
const TTL_DAYS = 30;

interface Stored {
  code: string;
  exp: number;
}

export function captureRefCode(ref: string | null | undefined): string | null {
  if (typeof window === "undefined" || !ref) return null;
  try {
    const cleaned = String(ref).trim().toUpperCase().slice(0, 60);
    if (!/^[A-Z0-9-]{3,60}$/.test(cleaned)) return null;
    const payload: Stored = { code: cleaned, exp: Date.now() + TTL_DAYS * 86400_000 };
    localStorage.setItem(KEY, JSON.stringify(payload));
    return cleaned;
  } catch {
    return null;
  }
}

export function captureRefFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    return captureRefCode(params.get("ref"));
  } catch {
    return null;
  }
}

export function getStoredRef(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Stored;
    if (!parsed?.code || !parsed?.exp || Date.now() > parsed.exp) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed.code;
  } catch {
    return null;
  }
}

export function clearStoredRef() {
  if (typeof window === "undefined") return;
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
